/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:52:22
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:48:34
 * @FilePath: \unified-development-platform\src\store\modules\move-auth\sysRolesManagement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {get_enable_roles, get_role_list}  from  '@/apis/auth/move-auth/app/role_manage_api';

const types = {
  GET_ALL_ROLES: 'GET_ALL_ROLES',
  GET_CANCHOOSE_ROLES: 'GET_CANCHOOSE_ROLES'
};
const state = {
  allRoles: [],
  canChooseRoles: []
};
const actions = {
  async getAllRoles(context,params) {
    const roles = await get_role_list(params);
    if (roles) {
      context.commit(types.GET_ALL_ROLES, roles);
    }
  },
  async getEnableRoles(context, params) {
    const roles = await get_enable_roles(params);
    if (roles) {
      context.commit(types.GET_CANCHOOSE_ROLES, roles);
    }
  }
};
const mutations = {
  [types.GET_ALL_ROLES](state, payload) {
    state.allRoles = payload;
  },
  [types.GET_CANCHOOSE_ROLES](state, payload) {
    state.canChooseRoles = payload;
  }
};
const getters = {
  allRoles: (state) => state.allRoles,
  canChooseRoles: (state) => state.canChooseRoles
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
